import PropTypes from 'prop-types'
import styled from 'styled-components'

const DisplayFlex = styled('div')`
  align-items: ${props => props.alignItems};
  display: flex;
  justify-content: ${props => props.justifyContent};
`

DisplayFlex.propTypes = {
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string
}

export default DisplayFlex
